module.exports = {
    UserPrecision: 5,
    GroupPrecision: 3,
    MarketingPrecision: 4
}